/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Modal as AntdModal } from 'antd';
import clsx from 'clsx';

import ErrorMessage from '@atoms/ErrorMessage';
import Typography from '@atoms/Typography';

import s from './styles.module.less';

const Title = ({ children, subtitle, extra, titleLevel = 2 }) => (
  <>
    <div>
      <Typography.Title level={titleLevel}>{children}</Typography.Title>
      {subtitle && <Typography.Text className={s.subtitle}>{subtitle}</Typography.Text>}
    </div>
    {extra}
  </>
);

const Modal = ({
  className,
  children,
  title,
  subtitle,
  extra,
  footerDivider = true,
  width = 700,
  error,
  errors,
  concatenateApiErrors,
  apiErrorWithKey,
  disableTitle = false,
  titleLevel,
  ...props
}) => (
  <AntdModal
    className={clsx(className, s.custom, { [s.footerWithoutDivider]: !footerDivider })}
    closable={false}
    title={
      !disableTitle && (
        <Title titleLevel={titleLevel} subtitle={subtitle} extra={extra}>
          {title}
        </Title>
      )
    }
    width={width}
    {...props}
  >
    {children}
    {/* FIXME: error message won't fit if modal padding has been overriden. */}
    <ErrorMessage
      error={error || errors}
      gutter={40}
      concatenateApiErrors={concatenateApiErrors}
      apiErrorWithKey={apiErrorWithKey}
      className={s.error}
    />
  </AntdModal>
);

const HeroImage = ({ src, alt }) => <img src={src} alt={alt} className={s.heroImage} />;

const withHeroImage = ({ heroImageSrc, heroImageAlt, ...props }) => (
  <Modal extra={heroImageSrc && <HeroImage src={heroImageSrc} alt={heroImageAlt} />} {...props} />
);

Modal.Title = Title;
Modal.HeroImage = HeroImage;
Modal.withHeroImage = withHeroImage;

export default Modal;
